import { loadState, saveState } from 'utils/storage'
import { PAYMENT_RETURN_KEY } from './constants'

/**
 * Powrot z ekranu /payment/status po bramce / 3DS.
 * - paymentMethod: dodanie metody platnosci w Koncie (komunikaty o zapisie metody)
 * - invoice: platnosc za faktury - po porazce "Ponow platnosc" wraca na liste/ekran, z ktorego placono
 */
export type PaymentReturnKind = 'paymentMethod' | 'invoice'

export interface PaymentReturn {
  path: string
  kind: PaymentReturnKind
}

/** wpis ma termin waznosci, zeby porzucona proba nie przejela ekranu statusu przy kolejnej platnosci */
export const PAYMENT_RETURN_TTL = 30 * 60 * 1_000

export const savePaymentReturn = (path: string, kind: PaymentReturnKind) => {
  saveState({ path, kind, expiresAt: Date.now() + PAYMENT_RETURN_TTL }, true, PAYMENT_RETURN_KEY)
}

export const readPaymentReturn = (): PaymentReturn | null => {
  const saved: any = loadState(true, PAYMENT_RETURN_KEY, {})
  if (!saved?.path || !saved?.expiresAt || saved.expiresAt < Date.now()) return null
  // wpisy sprzed wprowadzenia `kind` pochodzily tylko z dodawania metody platnosci
  return { path: saved.path, kind: saved.kind === 'invoice' ? 'invoice' : 'paymentMethod' }
}

export const clearPaymentReturn = () => {
  try {
    sessionStorage.removeItem(PAYMENT_RETURN_KEY)
  } catch (_) { }
}
